"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMapObject = exports.getAbsoluteProperty = exports.untypedGetProp = void 0;
exports.untypedGetProp = (obj, ...args) => {
    let lastObj = obj;
    for (const key of args) {
        if (typeof lastObj !== "object" || lastObj === null) {
            return undefined;
        }
        lastObj = lastObj[key];
    }
    return lastObj;
};
function getAbsoluteProperty(obj, deepKey) {
    const keys = deepKey.split(".");
    let last = obj;
    for (const key of keys) {
        last = last === null || last === void 0 ? void 0 : last[key];
        if (last === null || typeof last !== "object")
            break;
    }
    return last;
}
exports.getAbsoluteProperty = getAbsoluteProperty;
exports.deepMapObject = (obj, decisionFn) => {
    const decision = decisionFn(obj, []);
    if (decision.stop) {
        return decision.newVal;
    }
    const helper = (prefixes, obj, final = {}) => {
        for (const key in obj) {
            const val = obj[key];
            const path = [...prefixes, key];
            const decision = decisionFn(val, path);
            if (decision.stop) {
                final[key] = decision.newVal;
            }
            else if (typeof val === "object") {
                final[key] = {};
                helper(path, obj[key], final[key]);
            }
        }
        return final;
    };
    const result = helper([], obj);
    return result;
};
